// Import the functions you need from the SDKs you need
import * as firebase from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithRedirect} from "firebase/auth";
import "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD-utyKHO_Gj4lR2h9eOaxCiwkgX5NQaKk",
  authDomain: "drivewise-ef9a0.firebaseapp.com",
  databaseURL: "https://drivewise-ef9a0-default-rtdb.firebaseio.com",
  projectId: "drivewise-ef9a0",
  storageBucket: "drivewise-ef9a0.appspot.com",
  messagingSenderId: "649092297538",
  appId: "1:649092297538:web:a91c3113687185b4c58edb",
  measurementId: "G-ZW7S785W5G"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

export const signInWithGoogle = () => signInWithRedirect(auth, provider);




// use the hack of having the device id be a part of the display name for the user (maybe email + )